import { DEFAULT_DESIGN_TOKENS, type HandshakeAckPayload } from './protocol.js';

/**
 * Synthesises a `HANDSHAKE_ACK` when the app runs outside the Kadanza iframe,
 * so `pnpm dev:web` boots straight into the UI at http://localhost:4200.
 *
 * The mock JWT is not verifiable, so the API must be running with
 * `ENVIRONMENT=dev` and a real token pasted into `VITE_DEV_JWT` for anything
 * that touches Kadanza data to work.
 */
export function buildMockAck(): HandshakeAckPayload {
  const env = import.meta.env;
  return {
    authToken: {
      jwt: env.VITE_DEV_JWT ?? 'dev.mock.jwt.no-verification',
      expires: String(Math.floor(Date.now() / 1000) + 3600),
    },
    extensionDetails: {
      extensionId: env.VITE_DEV_EXTENSION_ID ?? 'shopx-distribution',
      tenantId: env.VITE_DEV_TENANT_ID ?? '00000000-0000-0000-0000-000000000000',
      tenantDomain: env.VITE_DEV_TENANT_DOMAIN ?? 'shopx-sandbox',
      baseUrl: env.VITE_DEV_HOST_ORIGIN ?? 'https://shopx-sandbox.shopx.kadanza-uat.com',
      spaceId: 'dev-space',
      pageId: 'dev-page',
      locale: env.VITE_DEV_LOCALE ?? 'en-US',
    },
    designTokens: {
      primaryColor: env.VITE_DEV_PRIMARY_COLOR ?? DEFAULT_DESIGN_TOKENS.primaryColor,
      fontFamily: env.VITE_DEV_FONT_FAMILY ?? DEFAULT_DESIGN_TOKENS.fontFamily,
      borderRadius: env.VITE_DEV_BORDER_RADIUS ?? DEFAULT_DESIGN_TOKENS.borderRadius,
    },
  };
}

export function isRunningStandalone(): boolean {
  try {
    return window.parent === window;
  } catch {
    return false;
  }
}
